var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "dropDownMenuWrapper",
      class: {
        "dropDownMenuWrapper--dark": _vm.isDarkMode,
        "dropDownMenuWrapper--noTitle": !_vm.menuTitle,
      },
    },
    [
      _c(
        "button",
        {
          ref: "menu",
          staticClass: "dropDownMenuButton",
          class: { "dropDownMenuButton--dark": _vm.isDarkMode },
          on: { click: _vm.openClose },
        },
        [_vm._v("\n    " + _vm._s(_vm.menuTitle) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "iconWrapper",
          class: { "iconWrapper--noTitle": !_vm.menuTitle },
        },
        [
          _c("div", {
            staticClass: "bar1",
            class: { "bar1--open": _vm.isOpen, "bar1--dark": _vm.isDarkMode },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "bar2",
            class: { "bar2--open": _vm.isOpen, "bar2--dark": _vm.isDarkMode },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "bar3",
            class: { "bar3--open": _vm.isOpen, "bar3--dark": _vm.isDarkMode },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.isOpen
        ? _c(
            "section",
            {
              ref: "dropdownMenu",
              staticClass: "dropdownMenu",
              class: { "dropdownMenu--dark": _vm.isDarkMode },
              style: { top: _vm.dropdownMenuShift },
            },
            [
              _c("div", {
                staticClass: "menuArrow",
                class: { "menuArrow--dark": _vm.isDarkMode },
              }),
              _vm._v(" "),
              _vm._t("default"),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }